enum FacilityWebReservationTargetType {
  AVAILABLE = "AVAILABLE",
  NOT_AVAILABLE = "NOT_AVAILABLE",
}

export default FacilityWebReservationTargetType;
